export enum IApiStatus {
  Loading = 'loading',
  Done = 'done',
  Fail = 'fail',
}
